import { render, staticRenderFns } from "./ekko.default-hero.vue?vue&type=template&id=5c48537e&scoped=true&"
import script from "./ekko.default-hero.vue?vue&type=script&lang=ts&"
export * from "./ekko.default-hero.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.default-hero.vue?vue&type=style&index=0&id=5c48537e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48537e",
  null
  
)

export default component.exports